const reducer = (state, action) => {
  const payload = action.payload;
  let updatedShipmentStatus = [];
  switch (action.type) {
    // ------ Shipment fields ------
    case "changeShipment":
      return { ...state, ...payload };

    // ------ Shipment statuses ------
    case "didCreateShipmentStatus":
      updatedShipmentStatus = [payload, ...state.shipmentStatus];
      updatedShipmentStatus.sort((a, b) => b.created - a.created);
      return { ...state, shipmentStatus: updatedShipmentStatus };

    case "updateShipmentStatus":
      updatedShipmentStatus = state.shipmentStatus.map((s) => {
        if (s.id === payload.id) return { ...s, ...payload };
        return s;
      });
      updatedShipmentStatus.sort((a, b) => b.created - a.created);
      return { ...state, shipmentStatus: updatedShipmentStatus };

    case "deleteShipmentStatus":
      return {
        ...state,
        shipmentStatus: state.shipmentStatus.filter((i) => i.id !== payload),
      };

    // ------ Shipment status errors ------
    case "createShipmentStatusError":
      return {
        ...state,
        newEtd: payload.shipment.newEtd,
        newEta: payload.shipment.newEta,
        shipmentStatus: state.shipmentStatus.map((s) => {
          if (s.id !== payload.shipmentStatusId) return s;
          return {
            ...s,
            errors: [payload.shipmentStatusError, ...s.errors],
          };
        }),
      };

    case "updateShipmentStatusError":
      return {
        ...state,
        newEtd: payload.shipment.newEtd,
        newEta: payload.shipment.newEta,
        shipmentStatus: state.shipmentStatus.map((s) => {
          if (s.id !== payload.shipmentStatusId) return s;
          return {
            ...s,
            errors: s.errors.map((e) => {
              if (e.id !== payload.shipmentStatusError.id) return e;
              return payload.shipmentStatusError;
            }),
          };
        }),
      };

    case "deleteShipmentStatusError":
      return {
        ...state,
        newEtd: payload.shipment.newEtd,
        newEta: payload.shipment.newEta,
        shipmentStatus: state.shipmentStatus.map((s) => {
          if (s.id !== payload.shipmentStatusId) return s;
          return {
            ...s,
            errors: s.errors.filter(
              (e) => e.id !== payload.shipmentStatusErrorId,
            ),
          };
        }),
      };

    // ------ Shipment invoices ------
    case "createShipmentInvoiceFromOdoo":
      return {
        ...state,
        ...payload.shipment,
        shipmentInvoices: state.shipmentInvoices.find(
          (x) => x.id === payload.shipmentInvoice.id,
        )
          ? state.shipmentInvoices.map((shipmentInvoice) => {
              if (shipmentInvoice.id !== payload.shipmentInvoice.id)
                return shipmentInvoice;
              return payload.shipmentInvoice;
            })
          : [...state.shipmentInvoices, payload.shipmentInvoice],
      };

    case "createShipmentInvoiceRow":
      return {
        ...state,
        ...payload.shipment,
        shipmentInvoices: state.shipmentInvoices.map((shipmentInvoice) => {
          if (shipmentInvoice.id !== payload.shipmentInvoiceId)
            return shipmentInvoice;
          return {
            ...shipmentInvoice,
            shipmentInvoiceRows: [
              ...shipmentInvoice.shipmentInvoiceRows,
              payload.shipmentInvoiceRow,
            ],
          };
        }),
      };

    case "deleteShipmentInvoice":
      return {
        ...state,
        ...payload.shipment,
        shipmentInvoices: state.shipmentInvoices.filter(
          (i) => i.id !== payload.id,
        ),
      };

    case "deleteShipmentInvoiceRow":
      return {
        ...state,
        ...payload.shipment,
        shipmentInvoices: state.shipmentInvoices.map((shipmentInvoice) => {
          if (shipmentInvoice.id !== payload.shipmentInvoiceId)
            return shipmentInvoice;
          return {
            ...shipmentInvoice,
            shipmentInvoiceRows: shipmentInvoice.shipmentInvoiceRows.filter(
              (row) => row.id !== payload.shipmentInvoiceRowId,
            ),
          };
        }),
      };

    case "updateShipmentInvoiceRow":
      return {
        ...state,
        ...payload.shipment,
        shipmentInvoices: state.shipmentInvoices.map((shipmentInvoice) => {
          if (
            shipmentInvoice.id !== payload.shipmentInvoiceRow.shipmentInvoice.id
          )
            return shipmentInvoice;
          return {
            ...shipmentInvoice,
            shipmentInvoiceRows: shipmentInvoice.shipmentInvoiceRows.map(
              (shipmentInvoiceRow) =>
                shipmentInvoiceRow.id === payload.shipmentInvoiceRow.id
                  ? payload.shipmentInvoiceRow
                  : shipmentInvoiceRow,
            ),
          };
        }),
      };

    // ------ Attachments ------
    case "addedShipmentAttachment":
      return {
        ...state,
        attachments: state.attachments.map((a, aIndex) => {
          if (aIndex !== payload.index) return a;
          return payload.attachment;
        }),
      };

    case "deleteShipmentAttachments":
      return {
        ...state,
        attachments: state.attachments.filter((_, index) => index !== payload),
      };

    case "onSelectAttachments":
      return {
        ...state,
        attachments: [...state.attachments, ...payload],
      };

    case "didUploadFileToAws":
      return {
        ...state,
        attachments: state.attachments.map((a, aIndex) => {
          if (aIndex !== payload.index) return a;
          return { ...a, uri: payload.url };
        }),
      };

    default:
      return state;
  }
};

export default reducer;
